var GLOBLE = {
  socketIoURL: "https://peer.ezinterview.org:8888"
};
document.onload = function () {
  /*---------------------注册全局变量-----------------------*/
  GLOBLE.navUser = document.getElementById("nav-user");
  GLOBLE.scrollTop = document.getElementById("scroll-top");
  /*-------------------导航栏展开收缩-----------------------*/
  document.addEventListener("click", function (e) {
    var e = e || window.event;
    var target = e.target || e.srcElement;
    try {
      var NAV_USER_STATE = GLOBLE.navUser.getAttribute("state");
      if (NAV_USER_STATE == "open") GLOBLE.navUser.setAttribute("state", "close");else if (target.id == "nav-user") GLOBLE.navUser.setAttribute("state", "open");
    } catch (error) {}
  });
  /*---------------------滚动到顶部按钮------------------------*/
  if (GLOBLE.scrollTop) {
    window.onscroll = function () {
      var t = document.documentElement.scrollTop || document.body.scrollTop;
      if (t == 0) GLOBLE.scrollTop.style.display = "none";else if (t >= 300) GLOBLE.scrollTop.style.display = "block";
    };
    GLOBLE.scrollTop.onclick = function () {
      window.scrollTo(0, 0);
    };
  }
}();
/*-------------------从数组删除指定元素----------------------*/
function removeByValue(arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] == val) {
      arr.splice(i, 1);
      break;
    }
  }
}
function removeByIndex(arr, index) {
  for (var i = 0; i < arr.length; i++) {
    if (i == index) {
      arr.splice(i, 1);
      break;
    }
  }
}
/*----------------判断数组是否存在某个值-----------------------*/
function arrayHasValue(array, value) {
  for (var i = 0; i < array.length; i++) {
    if (array[i] == value) return true;
  }
  return false;
}
/*-------------------比较两个时间值的大小---------------------*/
function compareTime(start, end) {
  var startHour = parseInt(start.split(":")[0]),
      startMinite = parseInt(start.split(":")[1]),
      endHour = parseInt(end.split(":")[0]),
      endMinite = parseInt(end.split(":")[1]);
  if (startHour > endHour) return true;else if (startHour < endHour) return false;else if (startMinite > endMinite) return true;else if (startMinite < endMinite) return false;else return true;
}
/*------------------------生成guid---------------------------*/
function getGUID() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var guid = s.join("");
  return guid;
}
/*---------------------生成唯一的guid------------------------*/
//参数array是正在使用的guid组成的数组
function getUUID(array) {
  var value = getGUID();
  if (arrayHasValue(array, value)) value = getUUID(array);else return value;
}

/*------------------判断某个时间是否已过去---------------------*/
function isPast(datetime) {
  var current = new Date().getTime();
  var compare = new Date(datetime).getTime();
  if (current >= compare) return true;else return false;
}
/*---------------------判断上传文件的大小----------------------*/
//第一个参数是input file元素，第二个参数是参考值，以M为单位
//如果大于参考值，返回true，否则返回false
function checkFileSize(ele, size) {
  //判断浏览器类型
  var browserCfg = {};
  var ua = window.navigator.userAgent;
  if (ua.indexOf("MSIE") >= 1) browserCfg.ie = true;else if (ua.indexOf("Firefox") >= 1) browserCfg.firefox = true;else if (ua.indexOf("Chrome") >= 1) browserCfg.chrome = true;else if (ua.indexOf("Safri") >= 1) browserCfg.safri = true;else if (ua.indexOf("like Gecko") >= 1) browserCfg.gecko = true;
  try {
    var fileSize = 0;
    if (browserCfg.firefox || browserCfg.chrome || browserCfg.safri || browserCfg.gecko) {
      for (var i = 0; i < ele.files.length; i++) {
        fileSize += ele.files[i].size;
      }
    } else return false;
    if (fileSize > 1024 * 1024 * size) return true;else return false;
  } catch (e) {
    return false;
  }
}

var AJAX_CONFIG = {
  projectEdit: "/interview/project/personal/update/",
  scheduleDelete: "/interview/schedule/delete/",
  interviewerGroupDelete: "/interview/interviewer/group/delete/",
  interviewerList: "/interview/schedule/interviewer/group/list/", //获取面试官列表
  projectTask: "/interview/project/task/",
  entryList: "/interview/schedule/entry/list/",
  entryDelete: "/interview/schedule/entry/delete/",
  entryResumeDelete: "interview/schedule/entry/resume/delete/", //删除简历
  entryDocumentDelete: "interview/schedule/entry/document/delete/", //删除资料
  entryCheckinList: "/interview/schedule/entries/checkin/list/",
  entryCheckinSwitch: "/interview/schedule/entry/checkin/switch/",
  entryCheckinBatchSwitch: "/interview/schedule/entry/batch/checkin/switch/", // 批量签到/取消签到
  entryCheckinAutoGroupSwitch: "/interview/schedule/entry/checkin/autogroup/", //签到页面自动分组开关
  entryCheckinDrewLotsSwitch: "/interview/schedule/entry/checkin/drewlots/", //签到页面考生抽签开关
  entryCheckinCheckAuthSwitch: "/interview/schedule/entry/checkin/auth/", //公安验证
  entryCheckinCheckIdSwitch: "/interview/schedule/entry/checkin/id/", //身份证识别签到
  entryCheckinCheckSwitch: "/interview/schedule/entry/checkin/qrcode/",
  entryGroupInfo: "/interview/schedule/entry/checkin/entrygroups/", //获取日程下候选组信息
  entryNotify: "/interview/schedule/entry/notify/", //发送邮件通知-候选人
  interviewerNotify: "/interview/schedule/interviewer/notify/", //发送邮件通知-面试官
  entryNotifyImageUpload: "/interview/schedule/entry/notify/image/upload/", //邮件图片上传
  entryGroupAdd: "/interview/schedule/group/add/",
  entryGroupEdit: "/interview/schedule/group/edit/",
  entryGroupNumberEdit: "/interview/schedule/group/number/edit/", //组内序号修改
  entryGroupNumber: "/interview/schedule/entry/group/number/edit/",
  groupEntryList: "/interview/schedule/group/entry/list/",
  groupEntryDelete: "/interview/schedule/group/entry/delete/",
  groupEntryTransfer: "/interview/schedule/group/entry/transfer/",
  groupState: "/interview/schedule/group/state/",
  groupDelete: "/interview/schedule/group/delete/",
  autoGroup: "/interview/schedule/group/auto/",
  autoGroupInfo: "/interview/schedule/group/auto/info/",
  groupEntryUsable: "/interview/schedule/group/entry/usable/",
  groupEntryAdd: "/interview/schedule/group/entry/add/",
  monitorInterviewerList: "/interview/schedule/monitor/interviewer/list/",
  monitorOperateFinish: "/interview/schedule/monitor/interviewer/operate/finish/",
  monitorOperateCancel: "/interview/schedule/monitor/interviewer/operate/finish/cancel/",
  monitorEntryList: "/interview/schedule/monitor/entry/list/",
  monitorConfirmHandle: "/interview/schedule/monitor/confirm/handle/",
  monitorDeleteInterviewer: "/interview/schedule/monitor/interviewer/delete/", //删除面试官打分结果
  arrangementAdd: "/interview/schedule/arrangement/add/",
  arrangementEdit: "/interview/schedule/arrangement/edit/",
  arrangementTimeEdit: "/interview/schedule/arrangement/time/edit/",
  arrangementDelete: "/interview/schedule/arrangements/delete/",
  arrangementEntryList: "/interview/schedule/arrangement/entry/usable/",
  arrangementEntryAdd: "/interview/schedule/arrangement/entry/add/",
  arrangementGroupAdd: "/interview/schedule/arrangement/group/add/",
  arrangementDrag: "/interview/schedule/arrangement/entries/exchange/", //拖拽修改安排顺序
  arrangementExchangeByNumber: "/interview/schedule/arrangement/entries/exchange_by_number/", //安排详情页，增加按编号升序接口
  arrangementExchangeByGroupNumber: "/interview/schedule/arrangement/entries/exchange_by_group_number/", //安排详情页，增加按组内编号升序接口
  scoreChartAdd: "/interview/score_chart/add/",
  scoreChartNameEdit: "/interview/score_chart/name/edit/",
  scoreCharGradingEdit: "/interview/score_chart/grading/edit/",
  scoreChartCopy: "/interview/score_chart/copy/",
  scoreChartDelete: "/interview/score_chart/delete/",
  scoreChartDetailEdit: "/interview/score_chart/detail/edit/",
  interviewerDelete: "/interview/interviewer/delete/",
  interviewerActive: "/interview/interviewer/active/",
  deleteInterviewer: "/interview/interviewer/delete/all/",
  usherDelete: "/interview/usher/delete/",
  usherActive: "/interview/usher/active/",
  deleteUsher: "/interview/usher/delete/all/",
  projectDelete: "/interview/project/delete/",
  addOrz: "/interview/console/organization/add/",
  addTestQue: "/interview/paper/edit/", //添加试题
  editTestQue: "/interview/paper/edit/", //编辑试题
  removeTestQue: "/interview/paper/delete/", //删除试题
  deleteUser: "/interview/management/user/delete/", //删除账号
  activeUser: "/interview/management/user/active/", //禁用账号
  interviewees: "/interview/project/interviewees/", //候选人名单
  /*------- 候选人名单页面删除操作 S-------*/
  intervieweeDelete: "/interview/project/interviewee/delete/", //删除候选人
  intervieweeAttachmentsDelete: "/interview/project/interviewee/attachments/delete/", //删除简历
  /*------- 候选人名单页面删除操作 E-------*/
  projectSchedulesInfo: "/interview/project/schedules/info/", //获取项目信息
  getScheduleInfo: "/interview/project/schedules/info", //获取日程信息
  scheduleEntryAddFromInterviewees: "/interview/schedule/entry/add/from/interviewees/", //添加候选人至面试日程
  intervieweesResultDetail: "/interview/project/interviewees/result/detail/", //候选人详情
  scheduleEntryNumberEdit: "/interview/schedule/entry/number/edit/", //编辑候选人编号
  getGroupInfo: "/interview/schedule/group/list/", //获取候选组信息
  getEntryCount: "/interview/schedule/group/entry/filter/count/", //获取候选人人数
  getArrangementList: "/interview/schedule/arrangement/list/", //获取安排列表
  getArrangementDetailList: "/interview/schedule/arrangement/detail/list/", //获取安排详情下的候选人列表
  deleteEntryFromArrangement: "/interview/schedule/arrangement/entry/delete/ ", //删除安排下的候选人
  getProjectInfo: "/interview/project/personal/",
  arrangementsDisplay: "/interview/schedule/arrangements/display/switch/", //面试安排链接是否可显示
  arrangementsDisplayList: "/interview/schedule/score_chart/arrangements/display/list/", //面试安排显示列表
  querySystemLogList: "/interview/system_log/query/" // 系统日志列表
};